import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

export default function PayPayButton({ onClick, disabled }) {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      disabled={disabled}
      sx={(theme) => ({
        width: "100%",
        padding: "8px",
        borderRadius: "27px",
        height: "54px",
        background: "transparent",
        "&:hover": {
          opacity: 0.9, // ホバー時の軽いエフェクト
        },
        ...theme.components.button,
      })}
      onClick={onClick}
    >
      {/* url(/paypay_logo.png)を使用する */}
      <img
        src={theme.assets?.payPayLogo || "/paypay_logo.png"}
        alt="PayPay"
        style={{ height: 44 }}
      />
    </Button>
  );
}
